import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fetchCurrencies, type Currency } from "@/lib/currencies/currenciesStore";
import { useEffect, useState } from "react";

type Props = {
  value: number | null;
  onChange: (next: number | null) => void;
  disabled?: boolean;
};

export function CurrencySelect({ value, onChange, disabled }: Props) {
  const [currencies, setCurrencies] = useState<Currency[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    fetchCurrencies()
      .then((rows) => {
        if (mounted) {
          setCurrencies(rows);
          // Default to PKR if none selected and PKR exists
          if (value == null && rows.length > 0) {
            const pkr = rows.find((c) => c.code === "PKR") || rows[0];
            onChange(pkr.id);
          }
        }
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const strValue = value != null ? String(value) : "";

  return (
    <div className="space-y-2">
      <Label className="text-xs text-muted-foreground">Company Base Currency</Label>
      <Select
        value={strValue}
        onValueChange={(v) => onChange(v ? Number(v) : null)}
        disabled={disabled || loading}
      >
        <SelectTrigger className="glass-input h-10">
          <SelectValue placeholder={loading ? "Loading currencies…" : "Select currency"} />
        </SelectTrigger>
        <SelectContent position="popper">
          {currencies.map((c) => (
            <SelectItem key={c.id} value={String(c.id)}>
              <span className="font-medium">{c.code}</span> ({c.symbol}) — {c.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
